import * as React from "react";
import * as ReactDOM from "react-dom";
import { Button } from "antd";
import { GuideIndicator } from "./guideIndicator";
import { guidePopupStyle, highlightTextStyle, guideHeaderStyle, guideProgressStyle, guideSkipStyle } from "./styles";
import { expandMenuSection } from "../store/menuSlice";
import { GuideProps } from "./guides";

export const AccountOrg: React.FC<GuideProps> = ({ onDone, onSkip, currentStep, totalSteps }) => {
  const [isReady, setIsReady] = React.useState(false);
  const [isManagementExpanded, setIsManagementExpanded] = React.useState(false);
  const [position, setPosition] = React.useState({ top: 0, left: 0 });

  // Auto-expand management section on mount
  React.useEffect(() => {
    expandMenuSection("management");
  }, []);

  // Track management section expanded state
  React.useEffect(() => {
    const update = () => {
      const section = document.querySelector('[data-guide="section-Management"]');
      if (section) {
        setIsManagementExpanded(section.getAttribute("data-expanded") === "true");
        const rect = section.getBoundingClientRect();
        const popupHeight = 200;
        const maxTop = window.innerHeight - popupHeight - 20;
        const top = Math.min(rect.top, maxTop);
        setPosition({ top: Math.max(20, top), left: rect.right + 20 });
      }
    };

    update();
    const intervalId = setInterval(update, 300);
    window.addEventListener("resize", update);
    return () => {
      clearInterval(intervalId);
      window.removeEventListener("resize", update);
    };
  }, []);

  // Show guide only after section is expanded and a delay has passed
  React.useEffect(() => {
    if (!isManagementExpanded) {
      return;
    }
    const timer = setTimeout(() => {
      setIsReady(true);
    }, 600);
    return () => clearTimeout(timer);
  }, [isManagementExpanded]);

  // Don't render anything until ready
  if (!isReady) {
    return null;
  }

  const orgsElement = document.querySelector('[data-guide="menu-Orgs"]');
  const orgsRect = orgsElement?.getBoundingClientRect();
  const popupHeight = 200;
  const maxTop = window.innerHeight - popupHeight - 20;
  const orgsPosition = orgsRect
    ? { top: Math.max(20, Math.min(orgsRect.top, maxTop)), left: orgsRect.right + 20 }
    : position;

  return (
    <>
      <GuideIndicator selector='[data-guide="menu-Orgs"]' />
      {ReactDOM.createPortal(
        <div style={{ position: "fixed", top: orgsPosition.top, left: orgsPosition.left, zIndex: 10001 }}>
          <div style={guidePopupStyle}>
            <div style={guideHeaderStyle}>
              <div className="font-semibold">
                <span className="mr-4 text-sm uppercase">GUIDE</span>Organization Management
              </div>
              <div style={guideProgressStyle}>{currentStep}/{totalSteps}</div>
            </div>
            <div className="text-sm mb-4">
              The <span style={highlightTextStyle}>highlighted item</span> shows where to manage organizations.
            </div>
            <div className="text-sm mb-4">
              Click "Orgs" to view, create, and manage your organizations. Use "Billing Accounts" for billing settings.
            </div>
            <div className="w-full flex justify-between items-center mt-4">
              <span style={guideSkipStyle} onClick={onSkip}>Skip all guides</span>
              <Button type={`primary`} onClick={onDone}>
                Done
              </Button>
            </div>
          </div>
        </div>,
        document.getElementById("guide")!,
      )}
    </>
  );
};
